import { module } from 'angular';
import App from '../../../app';

class SCR1907Controller {
	
	constructor ($scope, $state, $uibModalInstance, $timeout, httpService, utilService, gridService, codeService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		
		this.initWindow(700, 450);
		this.initText();
		
		this.$timeout(() => {
			this.initGridOption();
			this.initInfos();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'));
	}
	
	initGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setDisplayOptions({fitStyle: 'evenFill', rowHeight: 24, vscrollBar: true});
		this.gridView.setCheckBar({visible: true, showAll : false});
		var _this = this;
		
		this.dataProvider.setFields([
    		 {fieldName: "infoName"}, {fieldName: "preDepValue"}, {fieldName: "toDepValue"}, {fieldName: "confirmYn"}
        ]);
		
		this.gridView.setColumns([
			{ name: "infoName", fieldName: "infoName", header : { text: this.text.infoName }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "preDepValue", fieldName: "preDepValue", header : { text: this.text.preDepValue }, width: 100,
				styles: { textAlignment: 'center' }, renderer : { showTooltip:true }, displayCallback: function(grid, index, value){
					var prefldNm = grid.getValue(index.itemIndex, "infoName");
					return _this.getCodeValueName(prefldNm, value);
				} },
			{ name: "toDepValue", fieldName: "toDepValue", header : { text: this.text.toDepValue }, width: 100,
					styles: { textAlignment: 'center' }, renderer : { showTooltip:true }, displayCallback: function(grid, index, value){
					var tofldNm = grid.getValue(index.itemIndex, "infoName");
					return _this.getCodeValueName(tofldNm, value);
				} }
		]);
		
		this.gridView.onDataCellClicked = (grid, cell) => {
			let row = grid.getValues(cell.itemIndex);
			if(this.gridView.isCheckedItem(cell.itemIndex)){
				this.gridView.checkRow(row.__rowId, false);
			}else{
				this.gridView.checkRow(row.__rowId, true);
			}
		};
	}
	
	initInfos() {
		this.dataProvider.setRows(this.data);
	}
	
	closeModal(isOk){
		if(isOk){
			if(this.gridView.getCheckedRows().length == this.data.length){
				this.$uibModalInstance.close(true);
			}else{
				this.popupService.simpleAlert(this.$scope, this.text.checkValMsg);
				return;
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	getCodeValueName(tofldNm, value){
		if(tofldNm == this.text.timeOutProcMode){
			return this.codeService.getCodeValNm('TIMEOUT_PROC_CD', value);
		}else if(tofldNm == this.text.backupAprvStat){
			return this.codeService.getCodeValNm('BACKUP_CD', value);
		}else if(tofldNm == this.text.recordSeparator){
			return this.codeService.getCodeValNm('RECORD_SEPARATOR_CD', value);
		}else if(tofldNm == this.text.occurCycle){
			return this.codeService.getCodeValNm('GEN_CYCLE_CD', value);
		}else if(tofldNm == this.text.trxTypeDscd){
			var val = this.codeService.getCodeValNm('TRX_TYPE_DSCD', value);
			if(!val){
				val = this.codeService.getCodeValNm('TRX_TYPE_DSCD_CC', value);
			}
			return val? val : this.codeService.getCodeValNm('INTRFC_WAY_CD', value);
		}else if(tofldNm == this.text.syncAsyncDscd){
			return this.codeService.getCodeValNm('SYNC_DSCD', value);
		}else if(tofldNm == this.text.recvDbActionType){
			return this.codeService.getCodeValNm('RECV_DB_ACT_TYPE', value);
		}else if(tofldNm == this.text.sendTranBeforeScriptType){
			return this.codeService.getCodeValNm('TRAN_BEFORE_SCRIPT_TYPE', value);
		}else if(tofldNm == this.text.recvTranPostScriptType){
			return this.codeService.getCodeValNm('TRAN_POST_SCRIPT_TYPE', value);
		}else if(tofldNm == this.text.srTypeCd2){
			return this.codeService.getCodeValNm('SENC_RECV_DSCD', value);
		}
		
		return value;
	}
}

module(App.name).controller('SCR1907Controller', SCR1907Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1907/SCR1907.controller.js